import { render } from "./ManageBilling.vue?vue&type=template&id=28d913a2&scoped=true"
import script from "./ManageBilling.vue?vue&type=script&lang=js"
export * from "./ManageBilling.vue?vue&type=script&lang=js"

import "./ManageBilling.vue?vue&type=style&index=0&id=28d913a2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28d913a2"]])

export default __exports__